import { inject, Injectable, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { SwUpdate } from "@angular/service-worker";

@Injectable({
  providedIn: "root",
})
export class CheckForUpdateService {
  private readonly platformId: object = inject(PLATFORM_ID);
  private readonly updates: SwUpdate = inject(SwUpdate);

  constructor() {
    this.scheduleInitialCheck();
  }

  private scheduleInitialCheck(): void {
    window.setTimeout(() => {
      void this.checkUpdate();
    }, 1000);
  }

  async checkUpdate(): Promise<void> {
    if (!isPlatformBrowser(this.platformId) || !this.updates.isEnabled) {
      return;
    }

    try {
      const updateFound: boolean = await this.updates.checkForUpdate();
      console.log(
        updateFound
          ? "A new version is available."
          : "Already on the latest version."
      );

      if (updateFound) {
        await this.updates.activateUpdate();
        document.location.reload();
      }
    } catch (error: unknown) {
      console.error("Error checking for update:", error);
    }
  }
}
